import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import type React from 'react';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import materialTheme from '../materialTheme/index';

export type ThemeProviderProps = {
  readonly children?: React.ReactNode;
};

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={materialTheme}>
        <SCThemeProvider theme={materialTheme}>{children}</SCThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeProvider;
